import script from "./navBarMobile.vue?vue&type=script&lang=ts&setup=true"
export * from "./navBarMobile.vue?vue&type=script&lang=ts&setup=true"

import "./navBarMobile.vue?vue&type=style&index=0&id=0489dd74&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0489dd74"]])

export default __exports__